import { render, staticRenderFns } from "./AircraftPeopleBtn.vue?vue&type=template&id=a6efbe40&scoped=true&"
import script from "./AircraftPeopleBtn.vue?vue&type=script&lang=js&"
export * from "./AircraftPeopleBtn.vue?vue&type=script&lang=js&"
import style0 from "./AircraftPeopleBtn.vue?vue&type=style&index=0&id=a6efbe40&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6efbe40",
  null
  
)

export default component.exports